const MAP: Record<string, string> = {
    expired: 'reception.err-expired',
    revoked: 'reception.err-revoked',
    not_yet_valid: 'reception.err-not-yet',
    not_found: 'reception.err-not-found',
    exhausted: 'reception.err-exhausted',
};

export const verifyErrorKey = (errorId?: string): string => (errorId && MAP[errorId]) || 'reception.err-invalid';
